import posthog from "posthog-js";

// Generic LiveView hook that fires a PostHog custom event on mount.
//
// Usage: add a hidden element with phx-hook="PosthogEvent",
// data-event set to the event name, and data-properties set to a
// JSON-encoded object of event properties.
//
//   <div
//     id="track-my-event"
//     phx-hook="PosthogEvent"
//     class="hidden"
//     data-event="my_event"
//     data-properties={Jason.encode!(%{foo: "bar"})}
//   />
export const PosthogEvent = {
  mounted() {
    const event = this.el.dataset.event;
    const properties = JSON.parse(this.el.dataset.properties || "{}");
    posthog.capture(event, properties);
  },
};
